// CompanySelectorModal.js
import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  Avatar,
  IconButton,
  Chip,
  Fade,
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import DomainIcon from '@mui/icons-material/Domain';
import CloseIcon from '@mui/icons-material/Close';

const CompanySelectorModal = ({ open, onClose, companies = [], onSelect }) => {
  const userString = sessionStorage.getItem('Usuario') || 'Usuario';

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    if (onClose) onClose();
  };

  return (
    <Dialog
      open={open}
      disableRestoreFocus
      onClose={handleClose}
      disableEscapeKeyDown
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 300 }}
      PaperProps={{
        sx: {
          borderRadius: '20px',
          padding: 'clamp(18px, 3vh, 28px) clamp(16px, 3vw, 24px)',
          maxWidth: 'clamp(280px, 30vw, 380px)',
          width: '88%',
          boxShadow: '0 16px 36px rgba(0, 0, 0, 0.22)',
          border: '1px solid rgba(226, 232, 240, 0.9)',
          backgroundColor: '#fafbfc',
          position: 'relative',
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(4px)',
        },
      }}
    >
      {onClose && (
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: '#64748b',
            '&:hover': { color: '#1e293b', bgcolor: '#f1f5f9' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}

      <Box sx={{ textAlign: 'center', width: '100%' }}>
        <Avatar
          sx={{
            width: 'clamp(38px, 4.5vh, 48px)',
            height: 'clamp(38px, 4.5vh, 48px)',
            bgcolor: '#0655A5',
            mx: 'auto',
            mb: 1,
            boxShadow: '0 6px 14px rgba(6, 85, 165, 0.25)',
          }}
        >
          <BusinessIcon sx={{ fontSize: 'clamp(20px, 2.4vh, 24px)', color: '#ffffff' }} />
        </Avatar>

        <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', mb: 0.25, fontSize: 'clamp(1rem, 1.8vh, 1.18rem)', letterSpacing: '-0.01em' }}>
          Bienvenido, {userString}
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 2, fontWeight: 500, fontSize: 'clamp(0.74rem, 1.2vh, 0.82rem)' }}>
          Selecciona la empresa con la que deseas operar
        </Typography>

        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1.1,
              maxHeight: 'clamp(200px, 40vh, 270px)',
              overflowY: 'auto',
              pr: 0.5,
            }}
          >
            {companies.map((company) => {
              const isAll = company.EMPRESAID === 'ALL';
              return (
                <Button
                  key={company.EMPRESAID}
                  variant="outlined"
                  onClick={() => onSelect(company)}
                  startIcon={isAll ? <DomainIcon sx={{ color: '#0655A5', fontSize: 19 }} /> : <BusinessIcon sx={{ color: '#0655A5', fontSize: 19 }} />}
                  sx={{
                    justifyContent: 'flex-start',
                    textTransform: 'none',
                    borderRadius: '12px',
                    borderColor: '#cbd5e1',
                    bgcolor: '#ffffff',
                    color: '#1e293b',
                    fontWeight: 700,
                    py: 1.1,
                    px: 1.75,
                    fontSize: 'clamp(0.78rem, 1.3vh, 0.86rem)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      borderColor: '#0655A5',
                      bgcolor: '#f0f7ff',
                      transform: 'translateX(3px)',
                      boxShadow: '0 4px 10px rgba(6, 85, 165, 0.12)',
                    },
                    '&:focus': {
                      borderColor: '#0655A5',
                      bgcolor: '#f0f7ff',
                    }
                  }}
                >
                  <Box sx={{ textAlign: 'left', flex: 1 }} noWrap>
                    {company.NOMBRE_EMPRESA || company.nombre}
                  </Box>
                  {isAll && (
                    <Chip label="Todas" size="small" color="primary" sx={{ height: 20, fontSize: 10, fontWeight: 800, bgcolor: '#0655A5', borderRadius: '6px' }} />
                  )}
                </Button>
              );
            })}
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default CompanySelectorModal;
